import React from 'react';
import './FloatingIcons.css';

const FloatingIcons = () => {
  return (
    <div className="wc-ui-floating-foreground" aria-hidden="true">
      <div className="wc-ui-float-item wc-ui-f1"><i className="fa-solid fa-indian-rupee-sign"></i></div>
      <div className="wc-ui-float-item wc-ui-f2"><i className="fa-solid fa-chart-line"></i></div>
      <div className="wc-ui-float-item wc-ui-f3"><i className="fa-solid fa-coins"></i></div>
      <div className="wc-ui-float-item wc-ui-f4"><i className="fa-solid fa-shield-halved"></i></div>
      <div className="wc-ui-float-item wc-ui-f5"><i className="fa-solid fa-gem"></i></div>
      <div className="wc-ui-float-item wc-ui-f6"><i className="fa-solid fa-arrow-trend-up"></i></div>
      <div className="wc-ui-float-item wc-ui-f7"><i className="fa-solid fa-wallet"></i></div>
      <div className="wc-ui-float-item wc-ui-f8"><i className="fa-solid fa-building-columns"></i></div>
      <div className="wc-ui-float-item wc-ui-f9"><i className="fa-solid fa-piggy-bank"></i></div>
      <div className="wc-ui-float-item wc-ui-f10"><i className="fa-solid fa-hand-holding-dollar"></i></div>
    </div>
  );
};

export default FloatingIcons;
